<template>
    <router-view v-if="walletLimits"></router-view>
    <PaymentPolicy />
</template>
<script>
import { computed, defineAsyncComponent } from 'vue';
export default {
    name: "WalletModule",
    data() {
        return {
            walletLimits: null
        }
    },
    components: {
        PaymentPolicy: defineAsyncComponent(() =>
            import('../components/PaymentPolicy.vue')
        )
    },
    provide() {
        return {
            walletLimits: computed(() => this.walletLimits)
        }
    },
    created(){
        this.getWalletLimits()
    },
    methods:{
        getWalletLimits() {
            this.$apiCall('get', 'GET_WALLET_LIMIT').then(response => {
                if (response?.status == 200) {
                    if (response?.data?.error) {
                        this.$errorToast(response?.data?.error);
                    }
                    else {
                        this.walletLimits = response?.data?.data;
                        if(!this.walletLimits) {
                            this.$errorToast('Service not available. Please contact you admin!!');
                            this.$router.back();
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
    }
}
</script>